<div class="flex flex-col justify-center items-center w-full my-5 gap-8">
  <!-- Count Crads -->
<!--  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 w-full">-->
<!--    &lt;!&ndash; AGPM &ndash;&gt;-->
<!--    <sm-stat-card title="Nombre AGPM" [value]="533" [variation]="40"></sm-stat-card>-->
<!--    &lt;!&ndash; PAA &ndash;&gt;-->
<!--    <sm-stat-card title="Nombre PAA" [value]="20" [variation]="-10"></sm-stat-card>-->
<!--    &lt;!&ndash; PPM &ndash;&gt;-->
<!--    <sm-stat-card title="Nombre PPM" [value]="316" [variation]="20"></sm-stat-card>-->
<!--  </div>-->

<!--  <div class="grid grid-cols-1 2xl:grid-cols-2 gap-8 w-full">-->
<!--    <div class="content">-->
<!--      <sm-chart-builder [chart]="acChart"></sm-chart-builder>-->
<!--    </div>--> 
<!--    <div class="content">-->
<!--      <sm-chart-builder [chart]="chart"></sm-chart-builder>-->
<!--    </div>-->
<!--  </div>-->
</div>
